import { gql } from "@apollo/client";

export default gql`
  mutation removeTeamMemberMutation($teamId: Int!, $userId: Int!) {
    removeTeamMember(teamId: $teamId, userId: $userId) {
      user {
        id
        teams {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
`;
